import { useQuery } from '@tanstack/react-query';
import { getConfiguratorVisualization } from './configurator-visualization.api';
import { configuratorVisualizationKeys } from './configurator-visualization.queryKeys';

export function useConfiguratorVisualization(residentialUnitId: number, showroomPath?: string | null) {
    return useQuery({
        queryKey: configuratorVisualizationKeys.byUnit(residentialUnitId, showroomPath),
        queryFn: () => getConfiguratorVisualization(residentialUnitId, { showroomPath }),
        enabled: !!residentialUnitId,
    });
}
